export enum ShutdownStatus {
  Draft = 'Draft',
  Finalized = 'Finalized'
}

export enum ShutdownType {
  RegularReplacement = 'RegularReplacement',
  UnforeseenFailure = 'UnforeseenFailure',
  TemporaryStop = 'TemporaryStop'
}
